var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-note",style:({background: _vm.background})},[(_vm.type === 1 || _vm.type === 2)?_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/images/nodata.png"),"alt":""}})]):_vm._e(),(_vm.type === 0 || _vm.type === 2)?_c('div',{staticClass:"note"},[_c('p',[_vm._v(_vm._s(_vm.note))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }